<template>
    <div class="block">
        <Icon  slot="extra" :type="type" :color="icolor" size="40"/>
        <label class="text">{{ text }}</label>
        <h3 v-if="value" class="value">{{ value }}</h3>
        <slot v-else />
    </div>
</template>
<script>
export default {
    props: {
        type: {
            type: String,
            default: ""
        },
        icolor: {
            type: String,
            default: "#CCC"
        },
        text: {
            type: String,
            default: "Text Here"
        },
        value: {
            type: String,
            default: ""
        }
    }
}
</script>
<style>
.block {
    min-width: 100px;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
    cursor: pointer;
}
.block .text {
    font-size: 13px;
    color: #ccc;
    font-weight: 500;
    display: block;
}
.block .value {
    font-size: 14px;
    line-height: 1.8;
}
</style>


// WEBPACK FOOTER //
// src/components/profile/activity-block.vue